if (!customElements.get("m-our-story")) {
  class MOurStory extends HTMLElement {
    constructor() {
      super();

      this.enableSlider = this.dataset.enableSlider === "true";
      this.items = this.dataset.items;
      this.showPagination = this.dataset.showPagination === "true";
      this.showNavigation = this.dataset.showNavigation === "true";
      this.slideContainer = this.querySelector(".swiper-container");
    }

    connectedCallback() {
      this.lastActive = null;
      if (this.enableSlider) this.initSlider();
    }

    initSlider() {
      const controlsContainer = this.querySelector(".m-slider-controls");
      const prevButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-prev");
      const nextButton = controlsContainer && controlsContainer.querySelector(".m-slider-controls__button-next");
      const slideItemsLength = this.querySelector(".swiper-wrapper") ? this.querySelector(".swiper-wrapper").childElementCount : 0;
      let __this = this;

      if (!this.slideContainer) return;

      const itemsPerRow = parseInt(this.items) || 4;

      this.slider = new MinimogLibs.Swiper(this.slideContainer, {
        slidesPerView: 2.2,
        navigation: this.showNavigation,
        loop: true,
        pagination: this.showPagination
          ? {
            el: this.querySelector(".swiper-pagination"),
            clickable: true,
          }
          : false,
        breakpoints: {
          480: {
            slidesPerView: 2.4
          },
          640: {
            slidesPerView: itemsPerRow - 3
          },
          991: {
            slidesPerView: itemsPerRow - 2
          },
          1280: {
            slidesPerView: itemsPerRow - 1
          },
          1660: {
            slidesPerView: itemsPerRow,
          },
        },
        on: {
          init: function () {
            if (__this.lastActive !== null) {
              this.slideToLoop(__this.lastActive);
            }
            setTimeout(() => {
              // Calculate controls position
              const firstItem = __this.querySelector(".m-our-story-card") || __this.querySelector(".m-image") || __this.querySelector(".m-placeholder-svg");
              if (firstItem && controlsContainer) {
                const itemHeight = firstItem.clientHeight;
                controlsContainer.style.setProperty("--offset-top", parseInt(itemHeight) / 2 + "px");

                if (prevButton) prevButton.classList.remove("m:hidden");
                if (nextButton) nextButton.classList.remove("m:hidden");
              }
            }, 200);
          },
          breakpoint: (swiper, breakpointParams) => {
            if (controlsContainer) {
              const { slidesPerView } = breakpointParams;
              if (slideItemsLength > slidesPerView) {
                controlsContainer.classList.remove("m:hidden");
                swiper.allowTouchMove = true;
              } else {
                controlsContainer.classList.add("m:hidden");
                swiper.allowTouchMove = false;
              }
            }
          },
        },
      });

      if (this.slider && this.showNavigation) {
        if (prevButton) prevButton.addEventListener("click", () => this.slider.slidePrev());
        if (nextButton) nextButton.addEventListener("click", () => this.slider.slideNext());
      }
      document.addEventListener("shopify:block:select", (e) => this.onBlockSelect(e));
    }

    onBlockSelect(e) {
      const block = e.target;
      if (!block || !block.dataset) return;
      const index = Number(block.dataset.slide);
      this.lastActive = index;
      if (this.slider && !isNaN(index)) {
        this.slider.slideToLoop(index);
      }
    }
  }

  customElements.define("m-our-story", MOurStory);
}
